import React, { useState } from "react";
import { knowledgeAPI } from "../../services/api";
import Swal from "sweetalert2";

const Rating = ({ knowledgeId, initialRating, ratingCount }) => {
  const [rating, setRating] = useState(parseFloat(initialRating) || 0);
  const [count, setCount] = useState(ratingCount || 0);
  const [hoverRating, setHoverRating] = useState(0);
  const [userRating, setUserRating] = useState(0);
  const [loading, setLoading] = useState(false);

  const handleRating = async (value) => {
    // ตรวจสอบว่าผู้ใช้ล็อกอินหรือไม่ (optional)
    const token = localStorage.getItem("token");
    if (!token) {
      Swal.fire({
        icon: "warning",
        title: "กรุณาเข้าสู่ระบบ",
        text: "คุณต้องเข้าสู่ระบบก่อนให้คะแนน",
        confirmButtonText: "ตกลง",
      });
      return;
    }

    if (loading) return;

    setLoading(true);
    try {
      console.log("Submitting rating:", { id: knowledgeId, rating: value });

      const response = await knowledgeAPI.rate(knowledgeId, value);
      console.log("Rating response:", response);

      if (response.data.success) {
        setRating(response.data.data.rating);
        setCount(response.data.data.rating_count);
        setUserRating(value);

        Swal.fire({
          icon: "success",
          title: "ขอบคุณสำหรับการให้คะแนน",
          text: `คุณให้ ${value} ดาว`,
          showConfirmButton: false,
          timer: 1500,
          position: "top-end",
          toast: true,
        });
      }
    } catch (error) {
      console.error("Rating error:", error);

      let errorMessage = "ไม่สามารถให้คะแนนได้";
      if (error.response) {
        console.error("Error response:", error.response.data);
        errorMessage = error.response.data?.message || errorMessage;

        if (error.response.status === 400) {
          errorMessage = error.response.data?.message || "คุณได้ให้คะแนนแล้ว";
        } else if (error.response.status === 401) {
          errorMessage = "กรุณาเข้าสู่ระบบก่อนให้คะแนน";
        } else if (error.response.status === 404) {
          errorMessage = "ไม่พบ endpoint การให้คะแนน";
        }
      }

      Swal.fire({
        icon: "error",
        title: "ผิดพลาด",
        text: errorMessage,
        confirmButtonText: "ตกลง",
      });
    } finally {
      setLoading(false);
    }
  };

  const renderStars = () => {
    const stars = [];
    const displayRating = hoverRating || userRating || rating;
    const fullStars = Math.floor(displayRating);
    const hasHalfStar = displayRating - fullStars >= 0.5;

    for (let i = 1; i <= 5; i++) {
      let starClass = "far fa-star";
      let colorClass = "text-gray-300";

      if (hoverRating >= i) {
        starClass = "fas fa-star";
        colorClass = "text-blue-500";
      } else if (userRating >= i) {
        starClass = "fas fa-star";
        colorClass = "text-blue-600";
      } else if (rating >= i) {
        starClass = "fas fa-star";
        colorClass = "text-yellow-400";
      } else if (
        hasHalfStar &&
        i === fullStars + 1 &&
        !hoverRating &&
        !userRating
      ) {
        starClass = "fas fa-star-half-alt";
        colorClass = "text-yellow-400";
      }

      stars.push(
        <i
          key={i}
          className={`${starClass} ${colorClass} cursor-pointer transition-all duration-150 text-2xl hover:scale-110 ${loading ? "opacity-50 cursor-not-allowed" : ""}`}
          onMouseEnter={() => !loading && setHoverRating(i)}
          onMouseLeave={() => !loading && setHoverRating(0)}
          onClick={() => !loading && handleRating(i)}
          style={{
            filter: hoverRating >= i ? "drop-shadow(0 0 4px #3b82f6)" : "none",
          }}
        />,
      );
    }

    return stars;
  };

  return (
    <div className="flex flex-col sm:flex-row items-start sm:items-center gap-4">
      <div className="flex items-center gap-1">{renderStars()}</div>
      <div className="flex items-center gap-2 text-sm">
        <span className="font-semibold text-gray-700">{rating.toFixed(1)}</span>
        <span className="text-gray-500">
          ({count} {count === 1 ? "คะแนน" : "คะแนน"})
        </span>
        {userRating > 0 && (
          <span className="ml-2 text-xs text-blue-600 bg-blue-50 px-2 py-1 rounded-full">
            คุณให้ {userRating} ดาว
          </span>
        )}
        {loading && (
          <span className="ml-2 text-xs text-gray-500">
            <i className="fas fa-spinner fa-spin mr-1"></i>
            กำลังดำเนินการ...
          </span>
        )}
      </div>
    </div>
  );
};

export default Rating;
